/**
* Scrolling Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const mm = gsap.matchMedia();
      mm.add( '(min-width: 1024px)', () => {
        $( '.scrolling-cards' ).each( function( key, val ) {
          const card1 = $( this ).find( '.scrolling-cards__card--1' )[0];
          const card2 = $( this ).find( '.scrolling-cards__card--2' )[0];
          const card3 = $( this ).find( '.scrolling-cards__card--3' )[0];
          const height = $( val ).outerHeight();

          let topOffset = $( '.navbar' ).outerHeight();

          if ( $( '#wpadminbar' ).length ) {
            topOffset += $( '#wpadminbar' ).outerHeight();
          }

          const mm = gsap.matchMedia();
          mm.add( '(min-width: 1024px)', () => {
            const mover = gsap.timeline( {
              scrollTrigger: {
                trigger: val,
                start: 'top ' + topOffset,
                end: '+=' + ( height / 2 ),
                scrub: 1,
              },
            } );

            mover.to( card1, {y: '0vh', ease: 'linear'}, 0 );
            mover.to( card2, {y: '0vh', ease: 'linear'}, 0.25 );
            mover.to( card3, {y: '0vh', ease: 'linear'}, 0.5 );
          } );

          mm.add( '(max-width: 1023px)', () => {
            mm.revert();
            $( '.scrolling-cards__card' ).removeAttr( 'style' );
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cards', COMPONENT );
} )( app );
